import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ConfirmationModal } from '../../Confirmation'
import { RadioGroup } from '../../Radio'

import { DOCUMENT_UPLOAD_DESTINATION_CURRENT } from './DocumentUploadDestinationModal.constants'
import { getDocumentUploadDestinationRadioOptions } from './DocumentUploadDestinationModal.utils'

import * as styles from './DocumentUploadDestinationModal.module.css'

function DocumentUploadDestinationModal({
  defaultValue = DOCUMENT_UPLOAD_DESTINATION_CURRENT,
  descriptionKey = 'RequestProfileTabDocuments.UploadDestinationDescriptionKey',
  options,
  submitButtonKey = 'RequestProfileTabDocuments.UploadDestinationSubmitBtnKey',
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  const [value, setValue] = useState(defaultValue)

  const radioOptions = getDocumentUploadDestinationRadioOptions(options)

  function handleSubmit() {
    onSubmit(value)
  }

  return (
    <ConfirmationModal
      actionButtonsProps={{ submitText: t(submitButtonKey) }}
      description={t(descriptionKey)}
      title={t('Common.AttentionModalTitleKey')}
      onCancel={onClose}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <RadioGroup
        className={styles.radioGroup}
        options={radioOptions}
        value={value}
        onChange={setValue}
      />
    </ConfirmationModal>
  )
}

export default DocumentUploadDestinationModal
